const stripUrl = (url: string) => {
  // Remove  (http:// or https://)
  url = url.replace(/(http|https):\/\//, '');
  // Remove trailing slash and everything after it
  url = url.split('/')[0];
  return url;
}

export default stripUrl;
